module.exports = __webpack_public_path__ + "VIPH19.png?4ebb57db8e8f82ed043a625c17d0fb0e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH19.png
// module id = 91
// module chunks = 0